<template>
    <div class="caseSearch">
         <Row :gutter="10" style="margin-bottom: 10px;">
           <div v-if="companyIdCookie==1">
             <Col span="5">
               <Select v-model="companyId" filterable clearable :placeholder="$t('ticket.list.selectByCompany')" :transfer="true">
                 <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                 <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
               </Select>
             </Col>
           </div>
            <Col span="5">
                <Input v-model="ticketEntityId" clearable :placeholder="$t('ticket.list.selectByCaseId')"/>
            </Col>
            <Col span="5">
                <Select v-model="priorityId" filterable multiple :max-tag-count="1" :placeholder="$t('ticket.list.selectByPriority')" :transfer="true">
                    <Checkbox v-model="priorityIdCheckbox" @on-change="selectOurCompanyAll" style="display: block;text-align:right;">全选</Checkbox>
                    <Option :value="item.id" v-for="item in priorityIdList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="5">
                <DatePicker type="daterange" format="yyyy-MM-dd" placement="bottom-end" v-model="range" :placeholder="$t('ticket.list.selectByDate')" @on-change="range=$event" style="width:100%" @on-clear="handleClear()"></DatePicker>
            </Col>
        </Row>
        <Row :gutter="10">
            <Col span="5">
                <Select v-model="status" filterable clearable :placeholder="$t('ticket.list.selectByStatus')" :transfer="true">
                    <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                    <Option :value="item.id" v-for="item in statusList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="5">
                <Select v-model="ticketCategory" filterable clearable :placeholder="$t('ticket.list.selectByProblemTypes')" :transfer="true">
                    <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                    <Option :value="item.id" v-for="item in ticketCategoryList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="5">
                <Input v-model="assigneeUserName" clearable :placeholder="$t('ticket.list.selectByOperator')"/>
            </Col>
        </Row>
        <Row :gutter="10" style="margin-top: 10px;">
            <Col span="5">
                <Select v-model="cloudPlatformType" filterable clearable placeholder="云平台类型" :transfer="true" @on-change="onCloudPlatformChange">
                    <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                    <Option :value="item.id" v-for="item in cloudPlatformTypeList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="5">
                <Select v-model="monitorModule" filterable clearable placeholder="监控模块" :transfer="true" @on-change="onMonitorModuleChange">
                    <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                    <Option :value="item.id" v-for="item in monitorModuleList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="5">
                <Tooltip :disabled="monitorIndexEnabled" content="请先选择云平台类型和监控模块" placement="top" :transfer="true" style="width: 100%;">
                    <Select v-model="monitorIndex" filterable clearable placeholder="监控指标" :transfer="true" :disabled="!monitorIndexEnabled">
                        <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                        <Option :value="item.id" v-for="item in monitorIndexList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </Tooltip>
            </Col>
            <Col span="6">
                <div style="display: flex; align-items: center;">
                    <Button type="primary" @click="doSearch" style="margin-right: 8px;">查询</Button>
                    <add-case></add-case>
                </div>
            </Col>
        </Row>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../utils/cookieUtil.js'
    import AddCase from '../case/AddCase'
    import TableCase from '../case/TableCase'
    var tableCase = TableCase;
    export default {
        name: 'CaseSearch',
        components: {
            AddCase
        },
        data () {
            return {
                companyIdCookie:getCookie(global.companyId),
                ticketEntityId:'',
                priorityId:[],
                priorityIdCheckbox: false,
                companyId:'',
                companyList: [],
                assigneeUserName: '',
                priorityIdList:[
                {
                    id:0,
                    name:'P1'
                },
                {
                    id:1,
                    name:'P2'
                },
                {
                    id:2,
                    name:'P3'
                },
                {
                    id:3,
                    name:'P4'
                }],
                status:'',
                statusList:[],
                ticketCategory: '',
                cloudPlatformType: '',
                cloudPlatformTypeList: [],
                monitorModule: '',
                monitorModuleList: [],
                monitorIndex: '',
                monitorIndexList: [],
                createdTime: '',
                startTime: '',
                endTime: '',
                range:['',''],
                ticketCategoryList: []

            }
        },
        computed: {
            monitorIndexEnabled: function() {
                var hasCloudPlatform = this.cloudPlatformType !== '' && this.cloudPlatformType !== null && this.cloudPlatformType !== undefined;
                var hasMonitorModule = this.monitorModule !== '' && this.monitorModule !== null && this.monitorModule !== undefined;
                return hasCloudPlatform && hasMonitorModule;
            }
        },
        mounted: function(){
            this.getCompanyDropDownBox();
            this.getTicketCategoryDropDownBox();
            this.getCloudPlatformTypeList();
            this.getMonitorModuleList();
        },
        methods: {
            getCompanyDropDownBox: function(){
              this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                .then(res => {
                    this.companyList = res.data;
                });
            },
            getTicketCategoryDropDownBox: function(){
                this.$api.ticket.getProblemType({})
                  .then(res => {
                      // 问题类型
                      this.ticketCategoryList=res.data.problemTypeList;
                      this.statusList = res.data.stateList;
                  })
            },
            /***********优先级**************************/
            selectOurCompanyAll() {
                this.priorityId = []
                if (this.priorityIdCheckbox) {
                    this.priorityIdList.map((item) => {
                        this.priorityId.push(item.id)
                    })
                } else {
                    this.priorityId = []
                }
            },
            // 云平台联动：切换时重新加载监控指标列表
            onCloudPlatformChange: function(){
                this.monitorIndex = '';
                this.getMonitorIndexList();
            },
            // 监控模块或云平台联动：切换时重新加载监控指标列表
            onMonitorModuleChange: function(){
                this.monitorIndex = '';
                this.getMonitorIndexList();
            },
            // 统一查询
            doSearch: function(){
                // 处理日期范围
                if (this.range && this.range[0] && this.range[1]) {
                    this.startTime = new Date(this.range[0]);
                    this.endTime = new Date(this.range[1]);
                } else {
                    this.startTime = '';
                    this.endTime = '';
                }
                eventBus.$emit('ticketEntityId', this.ticketEntityId);
                eventBus.$emit('companyId', this.companyId);
                eventBus.$emit('priorityId', this.priorityId);
                eventBus.$emit('status', this.status);
                eventBus.$emit('ticketCategory', this.ticketCategory);
                eventBus.$emit('assigneeUserName', this.assigneeUserName);
                eventBus.$emit('startTime', this.startTime);
                eventBus.$emit('endTime', this.endTime);
                eventBus.$emit('cloudPlatformType', this.cloudPlatformType);
                eventBus.$emit('monitorModule', this.monitorModule);
                eventBus.$emit('monitorIndex', this.monitorIndex);
                tableCase.methods.showAll();
            },
            handleClear: function() {
                this.range = ['', ''];
                this.startTime = '';
                this.endTime = '';
            },
            getCloudPlatformTypeList: function(){
                this.$api.account.queryCloudList()
                .then(res => {
                    this.cloudPlatformTypeList = res.data || [];
                });
            },
            getMonitorModuleList: function(){
                this.$api.alertRule.searchMonitorModule("userName", getCookie(global.cookieName))
                .then(res => {
                    this.monitorModuleList = res.data || [];
                });
            },
            getMonitorIndexList: function(){
                if (!this.monitorIndexEnabled) {
                    this.monitorIndexList = [];
                    return;
                }
                var params = {
                    monitorModule: this.monitorModule,
                    cloudPlatform: this.cloudPlatformType
                };
                this.$api.alertRule.searchDefaultMonitorIndexByCloudPlatform(params)
                .then(res => {
                    this.monitorIndexList = res.data || [];
                });
            }
        }
    }
</script>
<style scoped>
    .caseSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/cases/case/CaseSearch.vue